// extracted by mini-css-extract-plugin
export default {"overflowHidden":"App__overflowHidden-mPR3"};